import React, { useEffect, useState } from "react";
import TextInput from "@components/textInput/TextInput";
import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import { observer } from "mobx-react-lite";
import { useMst } from "@store/Route";
import "../Manage.scss";
import ProfileHook from "./ProfileHook";
import { numberOnly } from "@utils/helper";

const Profile = observer(() => {
  const { profile, landing } = useMst();
  const { fetching, getProfile, profileUser, updateProfile } = profile;

  const [isEdit, setIsEdit] = useState(false);
  const [showPasswordInputAsText, setShowPasswordInputAsText] = useState(false);
  const [showModalChangePassword, setShowModalChangePassword] = useState(false);
  // temp for checking if email is already registered
  const [isEmailExisting, setEmailsExisting] = useState(false);

  const { formik, cancelEdit } = ProfileHook({
    getProfile,
    profileUser,
    updateProfile,
    token: landing.token,
  });

  return (
    <>
      {profileUser ? (
        <div className="flex flex-row mb-10 justify-between">
          <ButtonLoader
            type={"button"}
            className="w-72"
            isLoading={fetching === "pending"}
            onClick={() => {
              if (!isEdit) {
                setIsEdit(!isEdit);
              }
              if (isEdit) {
                formik.submitForm();
              }
            }}
          >
            {isEdit ? "Save" : "Edit"}
          </ButtonLoader>
          {isEdit ? (
            <ButtonLoader
              type="button"
              className="w-72 "
              isLoading={fetching === "pending"}
              onClick={() => {
                setIsEdit(false);
                cancelEdit();
              }}
              style={{ backgroundColor: "white" }}
              secondary
            >
              Cancel
            </ButtonLoader>
          ) : null}
        </div>
      ) : null}
      <section className="Manage__formWrapper mb-5">
        <div className="row no-gutters pl-3 pr-3"></div>
        {profileUser ? (
          <form
            onSubmit={(e) => {
              formik.submitForm();
              e.preventDefault();
            }}
          >
            <h1 className="pl-3 pr-3 mb-2 header--18">Profile Info</h1>
            <div className="row no-gutters">
              <div className="col-sm-6 pl-3 pr-3">
                <div className="formElements__group">
                  <label className="formElements__label">Salutation</label>
                  <select
                    {...formik.getFieldProps("salutation")}
                    className={`w-100 formElements__dropdown 
								${
                  formik.touched.salutation && formik.errors.salutation
                    ? "formElements__errorBorder"
                    : ""
                }`}
                    required
                    disabled={!isEdit}
                  >
                    <option value="placeholder" disabled>
                      Select your option
                    </option>
                    <option value="mrs">Mrs</option>
                    <option value="miss">Miss</option>
                    <option value="mr">Mr</option>
                    <option value="mdm">Mdm</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="row no-gutters">
              <div className="col-md-6">
                <TextInput
                  title="First Name *"
                  placeholder="Input First Name"
                  {...formik.getFieldProps("firstName")}
                  touched={formik.touched.firstName}
                  error={formik.errors.firstName}
                  disabled={!isEdit}
                ></TextInput>
              </div>
              <div className="col-md-6">
                <TextInput
                  title="Last Name *"
                  placeholder="Input Last Name"
                  {...formik.getFieldProps("lastName")}
                  touched={formik.touched.lastName}
                  error={formik.errors.lastName}
                  disabled={!isEdit}
                ></TextInput>
              </div>
            </div>

            <div className="row no-gutters">
              <div className="col-md-6">
                <TextInput
                  title="Email (This will be your log in id)*"
                  placeholder="Input Email"
                  {...formik.getFieldProps("email")}
                  touched={formik.touched.email}
                  error={formik.errors.email}
                  disabled
                  required
                ></TextInput>
                {isEmailExisting ? (
                  <p className="mb-3 text-red-500">
                    Email is registered, please login. If you do not know the
                    password, please click on Forget Password.
                  </p>
                ) : null}
              </div>
              <div className="col-md-6">
                <TextInput
                  title="Mobile No.*"
                  placeholder="Input Mobile No"
                  {...formik.getFieldProps("mobileNo")}
                  touched={formik.touched.mobileNo}
                  error={formik.errors.mobileNo}
                  disabled={!isEdit}
                  required
                ></TextInput>
              </div>
            </div>

            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="formElements__group">
                  <label className="formElements__label">Password</label>

                  <div className="formElements__inputWrapper_w_floater">
                    <input
                      className={`w-100 form-control formElements__input formElements--inputText
									${
                    formik.touched.password && formik.errors.password && isEdit
                      ? "formElements__errorBorder"
                      : ""
                  }
									`}
                      type={showPasswordInputAsText ? "text" : "password"}
                      placeholder="Input Password"
                      aria-errormessage="Password needs to be at least 6 characters long."
                      {...formik.getFieldProps("password")}
                      disabled={!isEdit}
                    />
                    {formik.touched.password &&
                    formik.errors.password &&
                    isEdit ? (
                      <div className="formElements__errorText">
                        {formik.errors.password}
                      </div>
                    ) : null}
                    <div className="invalid-feedback" />
                    <div
                      className="formElements__floaterElement is--text"
                      onClick={() => {
                        setShowPasswordInputAsText(!showPasswordInputAsText);
                      }}
                    >
                      {showPasswordInputAsText ? "hide" : "show"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row no-gutters pt-5">
              <h1 className="pl-3 pr-3 formElements__inputSectionHeader header--18">
                Billing Info
              </h1>
            </div>
            <div className="row no-gutters">
              <div className="col-md-12">
                <TextInput
                  title="Postal Code*"
                  placeholder="Input Postal Code"
                  {...formik.getFieldProps("postalCode")}
                  onChange={(event) => {
                    formik.setFieldValue(
                      "postalCode",
                      numberOnly(event.target.value)
                    );
                  }}
                  disabled={!isEdit}
                ></TextInput>
              </div>
            </div>

            <div className="row no-gutters">
              <div className="col-md-6">
                <TextInput
                  title="Unit No. (Optional)"
                  placeholder="Input Unit No"
                  {...formik.getFieldProps("unitNo")}
                  touched={formik.touched.unitNo}
                  disabled={!isEdit}
                  error={formik.errors.unitNo}
                  required={false}
                ></TextInput>
              </div>
              <div className="col-md-6">
                <TextInput
                  title="Building Name"
                  placeholder="Input Building Name"
                  {...formik.getFieldProps("buildingName")}
                  touched={formik.touched.buildingName}
                  error={formik.errors.buildingName}
                  disabled={!isEdit}
                ></TextInput>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-md-12">
                <TextInput
                  title="Block No.*"
                  placeholder="Input Block No"
                  {...formik.getFieldProps("blockNo")}
                  touched={formik.touched.blockNo}
                  error={formik.errors.blockNo}
                  disabled={!isEdit}
                  required
                ></TextInput>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-md-12">
                <TextInput
                  title="Address*"
                  placeholder="Input Address"
                  {...formik.getFieldProps("address")}
                  touched={formik.touched.address}
                  error={formik.errors.address}
                  disabled={!isEdit}
                  required
                ></TextInput>
              </div>
            </div>

            <div className="row no-gutters">
              <div className="col-md-12">
                <TextInput
                  title="Billing Name*"
                  placeholder="Input Billing Name"
                  {...formik.getFieldProps("billingName")}
                  touched={formik.touched.billingName}
                  error={formik.errors.billingName}
                  disabled={!isEdit}
                  required
                ></TextInput>
              </div>
            </div>

            <div className="row no-gutters">
              <div className="formElements__group">
                <label className="formElements__label">Billing emails *</label>
              </div>
              {formik.values.billingEmails.map((_, number) => {
                let billingEmail = formik.values.billingEmails[number];
                let billingEmailsTemp = [...formik.values.billingEmails];
                return (
                  <div className="row col-md-12 no-gutters" key={number}>
                    <div className="col-11">
                      <div className="formElements__group">
                        <input
                          className={`w-100 form-control formElements__input formElements--inputText
													${
                            formik.touched.billingEmails &&
                            formik.errors.billingEmails &&
                            formik.errors.billingEmails[number]
                              ? "formElements__errorBorder"
                              : ""
                          }
													`}
                          placeholder="Input Email"
                          required
                          type="email"
                          value={billingEmail}
                          onChange={(event) => {
                            billingEmailsTemp[number] = event.target.value;

                            formik.setValues({
                              ...formik.values,
                              billingEmails: billingEmailsTemp,
                            });
                          }}
                          disabled={!isEdit}
                        />
                      </div>
                    </div>
                    <div
                      className="col-1 pl-3 pr-3 formElements__floaterElement is--delete"
                      onClick={() => {
                        billingEmailsTemp.splice(number, 1);

                        formik.setValues({
                          ...formik.values,
                          billingEmails: billingEmailsTemp,
                        });
                      }}
                    ></div>
                  </div>
                );
              })}
            </div>
            <div
              className="row center add"
              onClick={() => {
                const billingEmailsTemp = formik.values.billingEmails;
                billingEmailsTemp.push("");

                formik.setValues({
                  ...formik.values,
                  billingEmails: billingEmailsTemp,
                });
              }}
            >
              + Add Billing email
            </div>
          </form>
        ) : (
          <div className="loaderWrapper">
            <div className="preloader preloaderBus" />
          </div>
        )}
      </section>
    </>
  );
});

export default Profile;
